import { Action } from 'redux';
import { PARTNER_DASHBOARD_CHECK } from 'src/modules/partner-dashboard/actions/PartnerDashboardActions';
import { PartnerDashboardState } from 'src/modules/partner-dashboard/types/PartnerDashboardState';

export function partnerDashboardAllowedReducer(state: PartnerDashboardState, action: Action): PartnerDashboardState {
  if (PARTNER_DASHBOARD_CHECK.is(action)) {
    return { ...state, allowed: action.data };
  }

  return state;
}
